module.exports = __webpack_public_path__ + "img/logo-5.0dc42c05.svg";